/* eslint-disable no-useless-escape */
/* eslint-disable no-shadow */
import React, {
  useEffect,
} from 'react';
import { connect } from 'react-redux';
import { businessActions, notificationActions } from 'store/actions';
import Loading from 'components/Loading';
import VerificationProcess from './components/VerificationProcess';
import VerifiedDetails from './components/VerifiedDetails';

type Props = {
  selectedAccount: Object,
  fetchPaypalVerification: Function,
  paypalVerification: Object,
  loading: Boolean,
};

const Virtualterminal = (props: Props) => {
  const {
    selectedAccount,
    fetchPaypalVerification,
    paypalVerification,
    loading,
  } = props;

  useEffect(() => {
    if (selectedAccount && selectedAccount?.gid) {
      fetchPaypalVerification(selectedAccount?.gid);
    }
  }, [selectedAccount?.gid]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      {!paypalVerification?.paypalStatus ? (
        <VerificationProcess />
      ) : <VerifiedDetails selectedAccount={selectedAccount} verificationDetails={paypalVerification} />}
    </div>
  );
};

const mapStateToProps = state => ({
  selectedAccount: state.account.selectedAccount,
  test: state.account.test,
  isSuperUser: state.user.superUser,
  loading: state.loading.loading,
  validator: state.loading.validator,
  paypalVerification: state.business.paypalVerification,
  submitting: state.loading.submitting,
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  fetchPaypalVerification: gid => dispatch(businessActions.fetchPaypalVerification({
    payload: gid,
  })),
});

// $FlowFixMe
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Virtualterminal);
